var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.load)?_c('base-renderer',{staticStyle:{"padding-bottom":"150px"},attrs:{"chiave":_vm.uuid(),"dati":_vm.json,"toggleBorders":_vm.toggleBorders,"logged":_vm.logged},on:{"end":function () {
				_vm.$emit('end')
			},"end2":function (val) {
				_vm.$emit('end2', val)
			}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }